import { IProfileIncompleteCookieEnum } from "@magnit/layer-api/typings/cookies";

export default defineNuxtRouteMiddleware(async (to, _) => {
  const router = useRouter();
  const { cookieJWT, cookieMagnitCode, profileIncompleteState } = useAuthCookies();
  const { apiCheckProfile } = useAuth();
  const { setAuthDestination } = useAuthDestination();

  if (!cookieJWT.value) {
    if ((profileIncompleteState.value === IProfileIncompleteCookieEnum.valid)) {
      profileIncompleteState.value = null;
    }
    if (cookieMagnitCode.value && to.path === Routes.Registration) {
      return;
    }

    if (privateRoutes.includes(to.path)) {
      setAuthDestination();
      // тут пока-что делаем через router,
      // т.к. navigateTo на SSR делает серверный редирект и он теряет инфу гидрации про authDestination
      return router.push(Routes.Main);
    } else if (to.path === Routes.ProfileIncomplete) {
      return navigateTo(Routes.Main);
    }
  } else {
    if (!profileIncompleteState.value ||
      profileIncompleteState.value === IProfileIncompleteCookieEnum.incomplete) {
      await apiCheckProfile();
    }
    await nextTick(async () => {
      if (profileIncompleteState.value === IProfileIncompleteCookieEnum.incomplete) {
        return navigateTo(Routes.ProfileIncomplete);
      }
    });

    if (to.path === Routes.Registration) {
      return navigateTo(Routes.Profile);
    }
  }
});
